module.exports = __webpack_public_path__ + "img/gsk.c2f3fda8.png";